export default "__VITE_PUBLIC_ASSET__c98e7200__"